module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-10",
    staticStyle: {
      "min-height": "500px"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "pa-4 border-bottom"
  }, [_c('label', {
    staticClass: "darkgrey--text font-size-12"
  }, [_vm._v("\n                    Chat Room ID\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "dense": "",
      "placeholder": "Masukan Chat Room ID",
      "disabled": _vm.param_cr_id,
      "readonly": _vm.param_cr_id
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearchMessage()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), (_vm.detail.status) ? _c('consul-chat-detail', {
    attrs: {
      "detail": _vm.detail
    }
  }) : _vm._e(), _vm._v(" "), (_vm.detail.status && !_vm.loading) ? _c('div', {
    staticClass: "pa-4"
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "#f0f3f9"
    }
  }, [_c('v-card-text', {
    staticClass: "py-2 text-center font-weight-500 greynew--text d-flex align-center justify-center"
  }, [_c('span', [_vm._v("\n                            " + _vm._s(_vm.$moment(_vm.detail.date).format("DD MMMM YYYY")) + "\n                        ")]), _vm._v(" "), (_vm.detail.status) ? _c('v-chip', {
    staticClass: "ml-2",
    attrs: {
      "color": _vm.getStatusColor(_vm.detail.status),
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.detail.status) + "\n                        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "mt-5 relative"
  }, [(_vm.checkingUserRole()) ? _c('div', {
    staticClass: "backdrop-blur"
  }, [_c('div', {
    staticClass: "text-center blacknew--text mt-10"
  }, [_c('v-icon', {
    attrs: {
      "color": "#f5ac2a",
      "size": "lg"
    }
  }, [_vm._v("mdi-lock")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-600 font-size-16 mt-2"
  }, [_vm._v("\n                                Restricted Access\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "black60--text"
  }, [_vm._v("\n                                Hanya dapat diakses oleh Head of Psychology.\n                            ")])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      key: index
    }, [(message.user_id === _vm.detail.teacher_id) ? _c('div', {
      staticClass: "d-flex gap-10 align-center mb-4"
    }, [_c('div', {
      staticClass: "font-size-12"
    }, [_vm._v("\n                                " + _vm._s(_vm.detail.teacher_name) + "\n                            ")]), _vm._v(" "), (message.type === 1) ? _c('div', {
      staticClass: "chat-teacher"
    }, [_vm._v("\n                                " + _vm._s(message.message) + "\n                            ")]) : _vm._e(), _vm._v(" "), (message.type === 2) ? _c('div', [_c('v-img', {
      staticClass: "chat-teacher-img",
      attrs: {
        "src": message.message
      }
    })], 1) : _vm._e(), _vm._v(" "), (message.type === 3) ? _c('div', [_c('a', {
      attrs: {
        "href": message.message,
        "filename": message.fileName,
        "target": "_blank"
      }
    }, [_c('v-list-item', {
      staticClass: "px-1 align-center gap-10 font-size-14"
    }, [_c('div', [_c('v-icon', [_vm._v("mdi-file")])], 1), _vm._v(" "), _c('div', [_vm._v("\n                                            " + _vm._s(message.fileName) + "\n                                        ")])])], 1)]) : _vm._e(), _vm._v(" "), (message.type === 4) ? _c('div', [_c('plyr', {
      ref: "plyr",
      refInFor: true,
      attrs: {
        "controls": [
          'play',
          'progress',
          'current-time',
          'duration' ]
      }
    }, [_c('audio', {
      attrs: {
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": message.message,
        "type": "audio/mp3"
      }
    })])])], 1) : _vm._e(), _vm._v(" "), (message.type === 5) ? _c('div', [_c('plyr', {
      ref: "plyr",
      refInFor: true,
      attrs: {
        "controls": [
          'play',
          'progress',
          'current-time',
          'duration' ]
      }
    }, [_c('video', {
      attrs: {
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": message.message,
        "type": "video/mp4"
      }
    })])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "font-size-12",
      attrs: {
        "align": "right"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#00cf3f",
        "small": ""
      }
    }, [_vm._v("\n                                    mdi-check-all\n                                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "-3px"
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.getTimeMessage(message.created_at)) + "\n                                ")])], 1)]) : _vm._e(), _vm._v(" "), (message.user_id === _vm.detail.student_id) ? _c('div', {
      staticClass: "d-flex gap-10 justify-end align-center mb-4"
    }, [_c('div', {
      staticClass: "font-size-12",
      attrs: {
        "align": "right"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#00cf3f",
        "small": ""
      }
    }, [_vm._v("\n                                    mdi-check-all\n                                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "-3px"
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.getTimeMessage(message.created_at)) + "\n                                ")])], 1), _vm._v(" "), (message.type === 1) ? _c('div', {
      staticClass: "chat-student"
    }, [_vm._v("\n                                " + _vm._s(message.message) + "\n                            ")]) : _vm._e(), _vm._v(" "), (message.type === 2) ? _c('div', [_c('v-img', {
      staticClass: "chat-student-img",
      attrs: {
        "src": message.message
      }
    })], 1) : _vm._e(), _vm._v(" "), (message.type === 3) ? _c('div', [_c('a', {
      attrs: {
        "href": message.message,
        "filename": message.fileName,
        "target": "_blank"
      }
    }, [_c('v-list-item', {
      staticClass: "px-1 align-center gap-10 font-size-14"
    }, [_c('div', [_c('v-icon', [_vm._v("mdi-file")])], 1), _vm._v(" "), _c('div', [_vm._v("\n                                            " + _vm._s(message.fileName) + "\n                                        ")])])], 1)]) : _vm._e(), _vm._v(" "), (message.type === 4) ? _c('div', [_c('plyr', {
      ref: "plyr",
      refInFor: true,
      attrs: {
        "controls": [
          'play',
          'progress',
          'current-time',
          'duration' ]
      }
    }, [_c('audio', {
      attrs: {
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": message.message,
        "type": "audio/mp3"
      }
    })])])], 1) : _vm._e(), _vm._v(" "), (message.type === 5) ? _c('div', [_c('plyr', {
      ref: "plyr",
      refInFor: true,
      attrs: {
        "controls": [
          'play',
          'progress',
          'current-time',
          'duration' ]
      }
    }, [_c('video', {
      attrs: {
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": message.message,
        "type": "video/mp4"
      }
    })])])], 1) : _vm._e()]) : _vm._e()])
  })], 2)], 1) : _vm._e(), _vm._v(" "), (!_vm.detail.status && !_vm.loading) ? _c('div', {
    staticClass: "pa-3"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                            " + _vm._s(_vm.search_status ?
    "Data chat konsul tidak ditemukan" :
    "Masukan cr_id untuk memulai pencarian data chat konsul") + "\n                        ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "text-center pa-10"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d66331cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/components/ConsulChatList.vue
// module id = 1654
// module chunks = 1